export const formatVehiclePrice = (value) =>
  `Rp${value.toLocaleString('id-ID')}`;

const variant = (type, priceValue, extra = {}) => ({
  type,
  priceValue,
  price: formatVehiclePrice(priceValue),
  description: 'NIK 2026',
  ...extra,
});

export const vehiclePrices = {
  atto1: [
    variant('Standard', 199000000),
    variant('Dynamic', 210000000),
    variant('Premium', 245000000),
  ],
  m6: [
    variant('Standard (7 Seater)', 395000000),
    variant('Superior (7 Seater)', 435000000),
    variant('Captain Seat (6 Seater)', 445000000),
  ],
  atto3: [variant('Advanced Plus', 415000000)],
  sealion7: [
    variant('NIK 2026 — Baterai baru', 879000000, {
      description: 'Satu varian | NIK 2026 | Baterai baru',
      details: [
        { label: 'NIK', value: '2026' },
        { label: 'Baterai', value: 'Baterai baru' },
        { label: 'Pilihan varian', value: '1 varian' },
      ],
    }),
  ],
  seal: [
    variant('NIK 2026 — Baterai baru', 869000000, {
      description: 'Satu varian | NIK 2026 | Baterai baru',
      details: [
        { label: 'NIK', value: '2026' },
        { label: 'Baterai', value: 'Baterai baru' },
        { label: 'Pilihan varian', value: '1 varian' },
      ],
    }),
  ],
};
